import React from "react";
import menuCart from "../assets/images/menu-cart.png";
import styles from "../css/cart.module.css";
import AppContext from "../contexts/appContext";

export default function CartIcon() {
  const { cart } = React.useContext(AppContext);
  return (
    <div className="flex">
      <img className="relative block z-10" src={menuCart} alt="Cart" height={40} width={40} />
      {cart?.length > 0 ? (
        <p className={`absolute  block z-20 text-black ${styles.cartCount}`}>{cart.length}</p>
      ) : null}
    </div>
  );
}
